export default __webpack_public_path__ + "static/media/add-picture.aba55a71.svg";